import * as React from 'react';
export const warningCircleSvg = React.forwardRef(function warningCircleSvgInner(
  props,
  ref,
) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M8 14.5A6.5 6.5 0 0 0 14.5 8c0-3.592-2.9-6.5-6.5-6.5A6.5 6.5 0 0 0 1.5 8 6.5 6.5 0 0 0 8 14.5ZM8 16a8 8 0 0 0 8-8c0-4.419-3.57-8-8-8a8 8 0 0 0-8 8 8 8 0 0 0 8 8Z',
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'M9.25 11.25a1.25 1.25 0 1 1-2.5 0 1.25 1.25 0 0 1 2.5 0ZM7.053 4.999a.949.949 0 1 1 1.894 0L8.79 8a.79.79 0 0 1-1.578 0l-.159-3Z',
    }),
  );
});
warningCircleSvg.defaultProps = {
  width: '16',
  height: '16',
  viewBox: '0 0 16 16',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var warningCircle = {
  category: 'icon',
  colorable: true,
  name: 'warningCircle',
  svg: warningCircleSvg,
};
